import { render, staticRenderFns } from "./ReportContacted.vue?vue&type=template&id=2c139f8e&scoped=true"
import script from "./ReportContacted.vue?vue&type=script&lang=js"
export * from "./ReportContacted.vue?vue&type=script&lang=js"
import style0 from "./ReportContacted.vue?vue&type=style&index=0&id=2c139f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c139f8e",
  null
  
)

export default component.exports